import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OnboardingService } from '../services/onboarding/onboarding.service';
import { NavigationService } from '../services/navigation.service';
import { PlatformService } from '../services/platform.service';

export const onboardingGuard: CanActivateFn = async (route, state) => {
  const onboardingService = inject(OnboardingService);
  const navigationService = inject(NavigationService);
  const platformService = inject(PlatformService);

  const hasSeen = await onboardingService.hasSeenOnboarding();
  const isNative = platformService.isNative;

  if (!hasSeen && isNative) {
    navigationService.navigate(['/onboarding']);
    return false;
  }

  return true;
};
